import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "burbujas_admin_token";

const adminApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

// Attach token automatically
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally
adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(err);
  }
);

export const adminAuth = {
  login: async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    return data;
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
  },
  me: async () => {
    const { data } = await adminApi.get("/auth/me");
    return data;
  },
  isAuthenticated: () => !!localStorage.getItem(TOKEN_KEY),
};

export const adminOrders = {
  list: async (params = {}) => {
    const { data } = await adminApi.get("/admin/orders", { params });
    return data;
  },
  get: async (id) => {
    const { data } = await adminApi.get(`/admin/orders/${id}`);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await adminApi.patch(`/admin/orders/${id}`, payload);
    return data;
  },
  remove: async (id) => {
    const { data } = await adminApi.delete(`/admin/orders/${id}`);
    return data;
  },
  createManual: async (payload) => {
    const { data } = await adminApi.post("/admin/orders/manual", payload);
    return data;
  },
  syncMercadoPago: async (days = 90) => {
    const { data } = await adminApi.post(
      `/admin/mercadopago/sync?days=${days}`
    );
    return data;
  },
  exportCsv: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    return fetch(`${BACKEND_URL}/api/admin/orders/export/csv`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export const adminStats = {
  get: async () => {
    const { data } = await adminApi.get("/admin/stats");
    return data;
  },
};

export const adminProducts = {
  list: async () => {
    const { data } = await adminApi.get("/admin/products");
    return data;
  },
  update: async (id, payload) => {
    const { data } = await adminApi.patch(`/admin/products/${id}`, payload);
    return data;
  },
  create: async (payload) => {
    const { data } = await adminApi.post("/admin/products", payload);
    return data;
  },
  remove: async (id) => {
    const { data } = await adminApi.delete(`/admin/products/${id}`);
    return data;
  },
  syncCatalog: async () => {
    const { data } = await adminApi.post("/admin/update-products");
    return data;
  },
};

export const adminReminders = {
  get: async () => {
    const { data } = await adminApi.get("/admin/settings/refill-reminders");
    return data;
  },
  setEnabled: async (enabled) => {
    const { data } = await adminApi.put("/admin/settings/refill-reminders", { enabled });
    return data;
  },
};

export default adminApi;
